// extracted by mini-css-extract-plugin
module.exports = {"stars":"Stars_stars__KjJ_Y","star":"Stars_star__xxkXy"};